// removed by extract-text-webpack-plugin
module.exports = {"mobile-s":"320px","ipad-portrait":"768px","ipad":"1024px","desktop":"1366px","large":"1600px","extra-large":"1920px"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/foundations/Grids/FullWidth.css
// module id = 795
// module chunks = 0